import React from "react";
import "./pagestyles.css";
import Layout from "../components/Layout";

const News = () => (
    <Layout>

    </Layout>
)
  
export default News